import { motion } from "framer-motion";
import { STATS } from "../data/site";
import { fadeUp, stagger } from "../lib/animations";

export const Stats = () => {
  return (
    <section className="bg-white py-20 sm:py-28" data-testid="stats-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-gray-200 border border-gray-200 rounded-2xl overflow-hidden"
        >
          {STATS.map((s, i) => (
            <motion.div
              key={i}
              custom={i}
              variants={fadeUp}
              className="bg-white p-8 sm:p-10"
              data-testid={`stat-${i}`}
            >
              <div className="font-heading font-extrabold tracking-tighter text-4xl sm:text-6xl text-brand-ink">
                {s.value}
              </div>
              <div className="mt-3 text-sm text-brand-ink/55">{s.label}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
